// components/VideoPlayer/WordInfoModal/SaveWordButton.jsx

import React, { useState } from "react";
import { saveWord } from "../../../services/userSaveWordApi";
import { useNotification } from "../../../context/NotificationContext";
import { usePackagesModal } from "../../../context/PackagesModalContext";
import "./WordInfoModal.css";

const SaveWordButton = ({
  word,
  fromLang,
  toLang = "fa",
  meanings,
  subtitle,
  translateOfSubtitle,
  movieName,
  season,
  episode,
  isPremium,
  onSaveSuccess,
  onRequirePremium,
  onSaveComplete, // اضافه شد برای بستن مودال
}) => {
  const [saving, setSaving] = useState(false);
  const { showSuccess, showError } = useNotification();
  const { showPackages } = usePackagesModal();

  const handleSave = async () => {
    // فقط کاربران ویژه می‌تونن ذخیره کنن
    if (!isPremium) {
      if (onRequirePremium) {
        onRequirePremium("برای ذخیره لغت نیاز به اشتراک ویژه دارید");
      }
      return;
    }

    try {
      setSaving(true);

      const response = await saveWord({
        fromLang,
        toLang,
        word,
        meanings: [meanings || ""],
        subtitle: subtitle || "",
        translateOfSubtitle: translateOfSubtitle || "",
        subtitleStartTime: "", // در آینده اضافه می‌شود
        subtitleEndTime: "", // در آینده اضافه می‌شود
        movieName: movieName || "",
        type: "word",
        season: season || "",
        episode: episode || "",
        groups: [],
      });

      if (response?.success) {
        // نمایش پیام موفقیت
        showSuccess(`لغت "${word}" با موفقیت ذخیره شد`, {
          duration: 3000,
          position: "top-center",
        });

        if (onSaveSuccess) {
          onSaveSuccess();
        }

        // بستن مودال
        if (onSaveComplete) {
          onSaveComplete();
        }
      } else {
        // نمایش خطا (به جز 402)
        if (response?.status !== 402) {
          showError(response?.error || "خطا در ذخیره لغت", {
            duration: 4000,
            position: "top-center",
          });
        }
      }
    } catch (error) {
      console.error("خطا در ذخیره لغت:", error);

      // خطای 402 رو به بالا ارسال می‌کنیم
      if (error.response?.status === 402) {
        showPackages({
          onSelect: (pkg) => {
            // TODO: رفتن به صفحه پرداخت
          },
        });
        if (onRequirePremium) {
          onRequirePremium("سهمیه رایگان شما تمام شده است");
        }
      } else {
        showError("خطا در ارتباط با سرور", {
          duration: 4000,
          position: "top-center",
        });
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <button className="save-word-btn" onClick={handleSave} disabled={saving}>
      {saving ? "..." : "ذخیره"}
    </button>
  );
};

export default SaveWordButton;
